import Layout from '@/views/layout'

export default [{
    path: '/ay-account-manager',
    component: Layout,
    redirect: '/recharge-manage/index',
    meta: {
        title: 'member.memberAcMgr' //账户管理
    },
    children: [
        {
            path: 'recharge-manage/index',
            component: () => import('@/views/ay-account-manager/recharge-manage/index'),
            name: 'RechargeManage',
            meta: { title: 'fi.listFiRecharge'} // 充值管理
        },
        {
            path: 'recharge-manage/view',
            component: () => import('@/views/ay-account-manager/recharge-manage/view'),
            name: 'ViewRecharge',
            meta: { title: 'menu.fi.viewFiAcInput'}, // 充值管理 - 查看充值单详情
            hidden: true
        },
        {
            path: 'recharge-manage/recharge',
            component: () => import('@/views/ay-account-manager/recharge-manage/recharge'),
            name: 'AccountRecharge',
            meta: { title: 'fi.zhcz'}, // 充值管理 - 电子账户充值
            hidden: true
        },
        {
            path: 'withdraw-manage/index',
            component: () => import('@/views/ay-account-manager/withdraw-manage/index'),
            name: 'WithdrawManage',
            meta: { title: 'fiappl.manager'} // 提现管理
        },
        {
            path: 'withdraw-manage/view',
            component: () => import('@/views/ay-account-manager/withdraw-manage/view'),
            name: 'ViewApply',
            meta: { title: 'menu.fi.viewFiAcAppl'}, // 提现管理 - 查看提现申请
            hidden: true
        },
        {
            path: 'withdraw-manage/add',
            component: () => import('@/views/ay-account-manager/withdraw-manage/add'),
            name: 'AddApply',
            meta: { title: 'fiappl.apply'}, // 提现管理 - 申领
            hidden: true
        },
        {
            path: 'transfer-manage/index',
            component: () => import('@/views/ay-account-manager/transfer-manage/index'),
            name: 'TransferManage',
            meta: { title: 'FiAcTrans.listFiAcTrans'} // 转账管理
        },

        {
            path: 'transfer-manage/add',
            component: () => import('@/views/ay-account-manager/transfer-manage/add'),
            name: 'AddTransfer',
            meta: { title: 'po.paymode.4'}, // 转账管理 - 新建
            hidden: true
        },
        {
            path: 'account-inquire/index',
            component: () => import('@/views/ay-account-manager/account-inquire/index'),
            name: 'AccountInquire',
            meta: { title: 'menu.fi.account.item'} // 账户查询
        },
        {
            path: 'account-inquire/view',
            component: () => import('@/views/ay-account-manager/account-inquire/view'),
            name: 'ViewAccount',
            meta: { title: 'menu.fi.account.item'}, // 账户查询 - 查看
            hidden: true
        },
        {
            path: 'bonus-electronic-currency/index',
            component: () => import('@/views/ay-account-manager/bonus-electronic-currency/index'),
            name: 'BonusElectronicCurrency',
            meta: { title: 'Bonus.Electronic.Currency'}, // 奖金转电子币
        },
        {
            path: 'bonus-electronic-currency/add',
            component: () => import('@/views/ay-account-manager/bonus-electronic-currency/add'),
            name: 'BonusElectronicCurrencyAdd',
            meta: { title: 'Bonus.Electronic.Currency'}, //  奖金转电子币 - 新增
            hidden: true
        },
    ]
}]
